import * as React from 'react';
import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import { TableHead, Tooltip } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import styled from 'styled-components'
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import ReplyIcon from '@mui/icons-material/Reply';
import DeleteIcon from '@mui/icons-material/Delete';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import { useSelector } from 'react-redux'
import moment from 'moment';
import { useGetAssetsQuery, useGetForm13CompAssetsQuery, useUpdateAddAssetStatusMutation, useUpdateflowAddAssetMutation } from '../../../../features/addassets/addassetApiSlice'
import { useAddNewAssetFinalMutation } from "../../../../features/addassets/addassetfinalApiSlice"
import { TableContStyle, TableHeadStyle } from '../../../../Styles/TableStyles'
import useAuth from '../../../../features/hooks/useAuth'
import Popup from 'reactjs-popup';
import { PopupButton } from '../../../../Styles/CommonStyles'
import TextField from '@mui/material/TextField';
import { useGetUsersQuery } from '../../../../features/users/usersApiSlice';
import { Modal } from "@mui/material"; 
import Form_13 from '../../../CPWDForms/Page/Form_13';
import { PDFViewer, pdf } from '@react-pdf/renderer';
import { useCombineFilesMutation, useGetEpubFileQuery, useUploadFileMutation } from '../../../../features/fileupload/fileuploadApiSlice';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PdfModal from '../../../../data/pdfmodal';
import MyModal from './ePubModal'
import { useAddNewfinalpdfformMutation, useGetfinalpdfformQuery, useUpdatefinalpdfformMutation } from '../../../../features/finalpdfforms/finalpdfformsApiSlice';
import {HeadingWrap, Span, CommonButton } from '../../../../Styles/CommonStyles';


const StatusButton = styled.button`
width: 80px;
height: 30px;
padding: 5px 7px;
border: none;
border-radius:10px ;
background-color: ${({ type }) => {
    if (type === "approved") {
      return "lightgreen";
    }
    else if (type === "appByLev1") {
      return "#FCCB00";
    }
    else if (type === "draft") {
      return "#D32F2F";
    }
  }};
color: ${({ type }) => {
    if (type === "approved") {
      return "white";
    }
    else if (type === "appByLev1") {
      return "black";
    }
    else if (type === "draft") {
      return "lightgreen";
    }
  }};
`
const StyledIconButton = styled(IconButton)`
margin: 5px;
`
const ActionIconContainer = styled.div`
display: flex;
`
const StyledPreviewIcon = styled(VisibilityIcon)``
const SignIconContainer = styled.div``
const StyledSignIcon = styled(DesignServicesIcon)``
const SignButtonContainer = styled.div``
const ReturnButtonCont = styled.div`
margin-top: 25px;
padding: 15px;
`

const ModalWrapper = styled.div`
  background:white;
  padding:5px;
  border-radius:8px;
  width:90%;
  height:90% ;
  margin: auto;
  margin-top:30px;
  display:flex;
  flex-direction:column;
  align-items: center;
`
const ReturnButton = styled.button`
display: flex;
align-items: center;
justify-content: center;
/* box-sizing: border-box; */
cursor: pointer;
font-family: "Roboto","Helvetica","Arial",sans-serif;
font-weight: 600;
font-size: 0.75rem;
line-height: 1.75;
letter-spacing: 0.02857em;
text-transform: uppercase;
min-width: 64px;
height: 40px;
padding: 6px 16px;
border-radius: 4px;
border-width: 0;
color: #ebe6e6;
background-color: #008080;
box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
margin: 8px;
`
const DetailsCont = styled.div``
const DetailsWrapper = styled.div``
const DetailsItemWrap = styled.div`
display: flex;
flex-direction: column;
padding: 5px;
border: 2px solid black;
border-radius: 10px;
background-color: #97bcd5;
margin-top: 5px;
`
const NameRoleWrap = styled.div`
  display: flex;
justify-content: space-between;
`
const ItemWrapper = styled.div`
display: flex;
`
const KeyWrap = styled.div`
font-weight: bold;
margin-right: 10px;
`
const ActionWrapper = styled.div`
  display:flex;
`
const ValueWrap = styled.div``

const GeneratePDF = styled.div`
  color:blue;
  cursor:pointer;
`


const StyledPopup = styled(Popup)``
function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

let jsonData = {collection:"addasset", data:{}, type:"update", oldPath:"", dynamicKey:"form13pdf"}; // Update JSON data with actual data.
let combinedPdfInitial = {formtype:"", formno:"", store:"", filepaths:[], from_date:null, to_date:null, status:""};

export default function CustomPaginationActionsTable({ handlePreview }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [remark, setRemark] = useState('')
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState("");
  const [combinedPdf, setCombinedPdf] = useState(combinedPdfInitial);


  
  
  const [pdfModalData, setPdfModalData] = useState({});

  const [uploadFile, { isLoading:uploadLoading }] = useUploadFileMutation();

  const [combinefiles] =  useCombineFilesMutation();


  // logged in user info
  const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
  let user_current_office = (useSelector((state) => state.office.off))
  let user_current_role_array = roles[user_current_office]


  //fetch all addasset documents for appraoval
  const {
    data: assets,
    isSuccess,
    isError,
    error
  } = useGetAssetsQuery('assets', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });

  const { getasset } = useGetAssetsQuery('assets', {
    selectFromResult: ({ data }) => ({
      getasset: data?.entities
    }),
  })

  const {addassetcompiled} = useGetForm13CompAssetsQuery("form13compassets", {
    selectFromResult: ({ data }) => ({
      addassetcompiled: data?.entities
    }),
  })

 const {finalpdfforms} = useGetfinalpdfformQuery("finalpdfforms", {
    selectFromResult: ({ data }) => ({
      finalpdfforms: data?.entities
    }),
  }
 )
  //usercall/single user call
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  })

  // console.log(getasset)
  // console.log(assets?.entities)

  let tempdata = assets ? Object.values(assets?.entities) : []
  let tabledata = tempdata.filter(elm => (elm.addstatus === 'submitted' && elm.cur_store === user_current_office))
  const [addNewAssetFinal, { isLoading: newassetfinalloading }] = useAddNewAssetFinalMutation();
  const [updateAddAssetflow, { isLoading: flowfinalloading }] = useUpdateflowAddAssetMutation();
  const [addnewfinalpdf, {isLoading: finalpdfloading}] = useAddNewfinalpdfformMutation();
  const [updatefinalpdf, {isLoading:updatepdfloading}] = useUpdatefinalpdfformMutation();

  const isLoading = useMemo(() => 
    newassetfinalloading || 
    flowfinalloading || 
    finalpdfloading || 
    updatepdfloading || 
    uploadLoading, 
    [newassetfinalloading, flowfinalloading, finalpdfloading, updatepdfloading, uploadLoading]
  );
  

  const handleClose = () => setOpen(false);
  const handleClose1 = () => setOpen1(false);

  const generatePDFBlob = async (data) => {
    const blob = await pdf(<Form_13 arrayData={data} />).toBlob();
    return blob;
  };

  const handleOpenForm13pDF = async (event, Id) =>{
    console.log(event.target.name)
    setOpen(true)
    if(event.target.name === "level1"){
      setPdfModalData({"level":"L1", "id":Id})
    }
    if(event.target.name === "level2"){
      setPdfModalData({"level":"L2", "id":Id})
    }
    if(event.target.id === "generatepdf"){
      setPdfModalData({"level":"generatepdf", "id":Id})
    }    
  }

  const  closeModal = () =>{
    setModalIsOpen(false);
  };
  const handleApprove = async() => {
    if(pdfModalData?.level === "L1"){
      try {
        let flow_details = {
          person_details: { role: 'L1Approver_A', id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
          editstatus: false,
          status: 'appByLev1',
          remarks: remark,
          time_stamp: new Date()
        }
        let body = { id: pdfModalData?.id, flow_details: flow_details }
        await updateAddAssetflow(body)
        alert('Approved by Level1')
      } catch (err) {
        return alert(`Error:${err}`)
      }
    }
    if(["L2","generatepdf"].includes(pdfModalData?.level)){
      try {
        let flow_details = {
          person_details: { role: 'L2Approver_A', id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
          editstatus: false,
          status: 'approved',
          remarks: remark,
          time_stamp: new Date()
        }
        let finalPdfBody = {
          formtype:"form13",
          formno:"",
          store:assets?.entities?.[pdfModalData?.id]?.cur_store,
          filepaths:[],
          from_date:null,
          to_date:null,
          status:"open"
        }
        let body = { id: pdfModalData?.id, flow_details: flow_details }
        if(pdfModalData?.level === "L2"){
          const result1 = await updateAddAssetflow(body);
        }
        const result = await getasset[pdfModalData?.id];
        let { _id, id:lotid, tags, quantity, addstatus, status, remarks, flow_data,
          curr_editstatus, alloc_ofc, ...others } = result
        let finalbody = { cur_loc: "store", indi_issue: false, cur_user_name: "User not Defined", alloc_ofc: "Not Applicable", lot_id: _id, ...others }
        let array = []
        for (let i = 1; i <= quantity; i++) {
          let assetdata = { oem_tag: tags[i - 1]?.oem_tag, org_tag: tags[i - 1]?.org_tag?.length? tags[i - 1]?.org_tag: "", ...finalbody }
          array.push(assetdata)
        }
        console.log(array)
        if(pdfModalData?.level === "L2"){
          const result3 = await addNewAssetFinal({ assetlist: array });
        }
        const pdfBlob = await generatePDFBlob([assets?.entities?.[pdfModalData?.id]]);
        const folderName = `${assets?.entities?.[pdfModalData?.id]?.cur_store}form13`
        jsonData.data = {id: pdfModalData?.id}
        const formData = new FormData();
        formData.append('file', pdfBlob, "form13.pdf")
        formData.append('jsonData', JSON.stringify(jsonData));
        const res = await uploadFile({ formData, folder: folderName, tag:{type: 'FINALPDFFORM', id: 'LIST' } }).unwrap();
        console.log(Object.values(finalpdfforms)?.filter(x => (x.store === assets?.entities?.[pdfModalData?.id]?.cur_store && x.formtype === "form13"))?.length)
        if(!Object.values(finalpdfforms)?.filter(x => (x.store === assets?.entities?.[pdfModalData?.id]?.cur_store && x.formtype === "form13"))?.length){
          console.log("Entered here")
          finalPdfBody.formno = "form13001";
          finalPdfBody.filepaths = [res?.path];          
          finalPdfBody.from_date = assets?.entities?.[pdfModalData?.id]?.purchase_date;
          finalPdfBody.to_date = assets?.entities?.[pdfModalData?.id]?.purchase_date;
          const res1 = await addnewfinalpdf( finalPdfBody);
          alert("Final Pdf added successfully")
        } else {
          console.log("Entered 2")
          const finalPdfObject = Object.values(finalpdfforms)?.find( x => (x.store === assets?.entities?.[pdfModalData?.id]?.cur_store && x.formtype === "form13" && x.status === "open"));
          
          if(finalPdfObject){
            console.log("Entered 3")
            finalPdfBody.id = finalPdfObject.id
            finalPdfBody.formno = finalPdfObject.formno;
            finalPdfBody.filepaths = finalPdfObject.filepaths.concat([res?.path]);
            finalPdfBody.from_date = finalPdfObject.from_date;
            finalPdfBody.to_date = assets?.entities?.[pdfModalData?.id]?.purchase_date;
            if(finalPdfObject?.filepaths?.length === 29){
              finalPdfBody.status = "closed";
            }
            const res5 = await updatefinalpdf( finalPdfBody);
            console.log(res5)

            alert("Final Pdf updated successfully")
          } else {
            console.log("Entered 4")
            const finalPdfArray = Object.values(finalpdfforms)?.filter( x => (x.store === assets?.entities?.[pdfModalData?.id]?.cur_store && x.formtype === "form13" && x.status === "closed"));
            console.log(finalPdfArray?.length);
            finalPdfBody.formno = `form13${(finalPdfArray.length + 1).toString().padStart(3, '0')}`;
            finalPdfBody.filepaths = [res?.path];
            finalPdfBody.from_date = assets?.entities?.[pdfModalData?.id]?.purchase_date;
            finalPdfBody.to_date = assets?.entities?.[pdfModalData?.id]?.purchase_date;
            const res1 = await addnewfinalpdf( finalPdfBody);
            console.log(res1)
          }
        }

        alert ('Approved and asset added to store')
      } catch (err) {
        return alert(`Error:${err}`)
      }
    }
    setOpen(false);
  };
  
  const handleReturnClick = async (Id) => {
    try {
      if (user_current_role_array.includes('L1Approver_A')) {
        let flow_details = {
          person_details: { role: 'L1Approver_A', id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
          editstatus: true,
          status: getasset && getasset[Id]?.status,
          remarks: remark,
          time_stamp: new Date()
        }
        let body = { id: Id, flow_details: flow_details }
        await updateAddAssetflow(body)
        setIsPopupOpen(false)

      } else if (user_current_role_array.includes('L2Approver_A')) {
        let flow_details = {
          person_details: { role: 'L2Approver_A', id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
          editstatus: true,
          status: 'draft',
          remarks: remark,
          time_stamp: new Date()
        }
        let body = { id: Id, flow_details: flow_details }
        await updateAddAssetflow(body)
        setIsPopupOpen(false)
      }
    } catch (err) {
      return alert(`Error:${err}`)
    }
  }

  const handleViewForm13Pdf = async (id) => {
    const data = [assets?.entities?.[id]];
    const blob = await generatePDFBlob(data);
    const blobUrl = URL.createObjectURL(blob);
    setPdfBlobUrl(blobUrl);
    setModalIsOpen(true);
  }

  const rows = tabledata
  // handle sign of level-1 approver only status change
  const handleSign_L_1 = async (Id) => {
    setOpen(true)
    setPdfModalData({"level":"L1", "id":Id})   
  }


  // handle sign of level-2 approver, the all assets are allocated to store
  const handleSign_L_2 = async (Id) => {
    setOpen(true)
    setPdfModalData({"level":"L2", "id":Id})    
  }

  const handleClickTest = async () => {
    try{
      const res = await combinefiles({
        folder: "newDir-SMDform13", 
        pdfFiles: [
            {folder: "Dir-SMDform13", filename: "1737910647362-form13.pdf"}, 
            {folder: "Dir-SMDform13", filename: "1737910739519-form13.pdf"},
            {folder: "Dir-SMDform13", filename: "1737910748505-form13.pdf"}, 
            {folder: "Dir-SMDform13", filename: "1737910759184-form13.pdf"}, 
            {folder: "Dir-SMDform13", filename: "1737910764790-form13.pdf"}
        ], 
        outputFilename: "output2.pdf"
    });
    console.log(res);
    } catch (err) {
      return alert(`Error:${err}`)
    }
    alert("Files Combines Successfully")
  }

  const handleViewePub = async () => {
    setOpen1(true);
    // try{
    //   const res = await getePub({folder: "Dir-SMDform13", filename: "output.epub"});
    //   console.log(res);

    // } catch (err) {
    //   return alert(`Error:${err}`)
    // }
  }
  console.log(pdfModalData)

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
    <HeadingWrap>
      <Span>Approve Assets</Span>
    </HeadingWrap>
    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}>
      <Table sx={{ minWidth: 50 }} aria-label="custom pagination table">
        <TableHead>
          <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor }}>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">S.No</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Asset Name</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Order  No.</TableCell>

            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Model No.</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Quantity</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Unit Cost</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">OEM/Vendor</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Date of Purchase</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Status</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Actions</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Details</TableCell>
            <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="left">Signatories</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : rows
          ).map((row, index) => (
            <TableRow key={index}>
              <TableCell style={{ width: 5 }} component="th" scope="row">
                {(page)*(rowsPerPage)+index+1}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.name}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row?.orderno? row?.orderno:""}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.model_no}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.quantity}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.unit_price}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {row.oem}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                {moment(row.purchase_date).format('DD/MM/YYYY')}
              </TableCell>
              <TableCell style={{ width: 160 }} align="left">
                <StatusButton type={row.status}>{row.status}</StatusButton>
              </TableCell>
              <TableCell style={{ width: 200 }} align="left">
                <ActionWrapper>
                <ActionIconContainer>
                  <Tooltip title="Preview">
                    <StyledIconButton onClick={(e) => handlePreview(e, row._id)} color="primary" size='small'>
                      <StyledPreviewIcon />
                    </StyledIconButton>
                  </Tooltip>
                  {row.status === 'approved' || ((user_current_role_array?.includes('L1Approver_A') && row.status !== 'appByLev1') || (user_current_role_array?.includes('L2Approver_A') && row.status !== 'draft')) && row.curr_editstatus !== true && <div className="dropdown-container" style={{ width: '200px' }}>
                    <StyledPopup
                      trigger={
                        <PopupButton style={{ width: 140, minWidth: 'fit-content', padding: '8px 12px' }} className="button"> Return to modify </PopupButton>}
                      modal
                      nested
                      open={isPopupOpen}
                      onClose={() => setIsPopupOpen(false)}
                      contentStyle={{ maxHeight: '90%', overflowY: 'auto' }}
                    >
                      <TextField
                        style={{ width: '600px', marginTop: '20px', marginLeft: '20px' }}
                        inputProps={{ style: { height: '38px' } }}
                        value={remark} name='remarks' onChange={(event) => setRemark(event.target.value)} label="Remarks" size="medium" variant="outlined" />
                      <ReturnButtonCont>
                        <ReturnButton onClick={() => handleReturnClick(row._id)}>Confirm Return</ReturnButton>
                      </ReturnButtonCont>
                    </StyledPopup>
                  </div>}
                  {/* <Tooltip title="Delete">
                    <StyledIconButton disabled={["appByLev1", "approved"].includes(row.status)} onClick={() => handleDelete(row._id)} color="primary" size='small'>
                      <StyledDeleteIcon />
                    </StyledIconButton>
                  </Tooltip> */}
                </ActionIconContainer>
                {row?.form13pdf?.length ? <PictureAsPdfIcon style={{ color: "blue", fontSize: "30px", cursor:"pointer" }} onClick={() => handleViewForm13Pdf(row._id)} />:null}
                </ActionWrapper>

              </TableCell>
              <TableCell style={{ width: 100 }} align="right">
                <div className="dropdown-container" style={{ width: '100px' }}>
                  <StyledPopup
                    trigger={
                      <PopupButton style={{ width: 100 }} className="button"> Details </PopupButton>}
                    modal
                    nested
                    open={isPopupOpen}
                    onClose={() => setIsPopupOpen(false)}
                    contentStyle={{ width: '600px',maxHeight: 'auto', overflowY: 'auto' }}
                  >
                    < DetailsCont>
                      <DetailsWrapper>
                        {row.flow_data?.map((elm, ind) => <DetailsItemWrap key={ind}>
                          <NameRoleWrap>
                            <ItemWrapper>
                              <KeyWrap>Role:</KeyWrap>
                              <ValueWrap>{elm.person_details.role}</ValueWrap>
                            </ItemWrapper>
                            <ItemWrapper>
                              <KeyWrap>User Details:</KeyWrap>
                              <ValueWrap>{`${elm.person_details.name.firstName} ${elm.person_details.name.middleName} ${elm.person_details.name.lastName}- ${elm.person_details.designation}`}</ValueWrap>
                            </ItemWrapper>
                          </NameRoleWrap>
                          <ItemWrapper>
                            <KeyWrap>Status:</KeyWrap>
                            <ValueWrap>{elm.status}</ValueWrap>
                          </ItemWrapper>
                          {elm.remarks.length > 0 && <ItemWrapper>
                            <KeyWrap>Remark:</KeyWrap>
                            <ValueWrap>{elm.remarks}</ValueWrap>
                          </ItemWrapper>}
                          {elm.editstatus && <ItemWrapper>
                            <KeyWrap>Returned to modify:</KeyWrap>
                            <ValueWrap>{elm.editstatus && 'YES'}</ValueWrap>
                          </ItemWrapper>}
                        </DetailsItemWrap>)}
                      </DetailsWrapper>
                    </DetailsCont>
                  </StyledPopup>
                </div>
              </TableCell>
              <TableCell style={{ width: 300 }} align="right">
                <SignIconContainer>
                  {user_current_role_array?.includes('L1Approver_A') && <SignButtonContainer>
                    <StyledIconButton disabled={(row.status === "approved") || (row.status === "appByLev1") || (row.curr_editstatus === true)} onClick={(event) => handleOpenForm13pDF(event, row._id)} color="secondary" size='small' name="level1"><StyledSignIcon />
                      Level-I
                    </StyledIconButton>
                  </SignButtonContainer>}
                  {user_current_role_array?.includes('L2Approver_A') && <SignButtonContainer>
                    <StyledIconButton disabled={(row.status === "approved") || (row.status === "draft") || (row.curr_editstatus === true)} onClick={(event) => handleOpenForm13pDF(event, row._id)} color="secondary" size='small' name="level2"><StyledSignIcon />
                      Level-II
                    </StyledIconButton>
                  </SignButtonContainer>}
                  {/* <button onClick={handleClickTest}>click</button> */}
                  {/* <button onClick={handleViewePub}>view epub</button> */}
                </SignIconContainer>
                {(!row?.form13pdf?.length && row?.status === "approved") ? <GeneratePDF id='generatepdf' onClick={(event) =>handleOpenForm13pDF(event,row?._id)}>GeneratePdf</GeneratePDF>:null}
              </TableCell>
            </TableRow>
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={9}
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    <Modal open={open} onClose={handleClose}>
      <ModalWrapper>
        <h3>Preview PDF</h3>
      <div style={{ flex: 1, width: "100%", overflow: "auto" }}>
      <PDFViewer width={"100%"} style={{ minHeight: "100vh" }}>        
        <Form_13 arrayData = {[assets?.entities?.[pdfModalData?.id]]} />
      </PDFViewer>        
      </div>
      <button
        style={{
          marginTop: "10px",
          padding: "10px 20px",
          backgroundColor: isLoading ? "gray" : "green",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: isLoading ? "not-allowed" : "pointer",
          opacity: isLoading ? 0.6 : 1,
        }}
        onClick={handleApprove}
        disabled={isLoading}
      >
        {pdfModalData?.level === "L1"
          ? "Approve by Level1"
          : pdfModalData?.level === "generatepdf"
          ? "Generate PDF"
          : "Approve Final by Level2"}
      </button>

      </ModalWrapper>
    </Modal>
    <PdfModal
      show = {modalIsOpen}
      onClose = {closeModal}
      pdfUrl = {pdfBlobUrl}
    />
    <MyModal open={open1} handleClose={handleClose1} pdfUrl="http://localhost:5000/upload/files/Dir-SMDform13/output.pdf"/>
    </>

  );
}
